function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ash-brown': 'rgb(121, 104, 88)','olive-green': 'rgb(133, 133, 101)','slate-grey': 'rgb(75, 77, 83)','blaze-orange': 'rgb(231, 86, 40)','military-green': 'rgb(97, 91, 73)','heather-navy': 'rgb(80, 82, 97)','deep-navy': 'rgb(24, 35, 54)','sand': 'rgb(212, 196, 168)','cream': 'rgb(247, 228, 181)','loden': 'rgb(170, 172, 155)','bronze': 'rgb(205, 127, 50)','sage': 'rgb(157, 193, 131)','charcoal': 'rgb(109, 114, 117)','slate': 'rgb(80, 88, 95)','brown': 'rgb(82, 67, 60)','heather-grey': 'rgb(159, 160, 165)','charcoal-black': 'rgb(69, 64, 70)','charcoal-white': 'rgb(73, 72, 77)','khaki': 'rgb(168, 141, 112)','carmel': 'rgb(141, 81, 27)','heather-royal': 'rgb(30, 78, 131)','amber-gold': 'rgb(150, 113, 69)','smoke-blue': 'rgb(142, 172, 172)','army-olive': 'rgb(114, 115, 84)','loden-black': 'rgb(142, 136, 114)','coyote-brown': 'rgb(93, 73, 49)','indigo': 'rgb(96, 108, 127)','espresso': 'rgb(124, 106, 101)','dark-heather': 'rgb(109, 109, 107)','safari': 'rgb(150, 119, 100)','athletic-heather': 'rgb(171, 170, 178)','dark-grey-heather': 'rgb(78, 68, 76)','iron-grey': 'rgb(137, 136, 132)','heather-charcoal': 'rgb(28, 28, 26)','heather-brown': 'rgb(151, 141, 127)','heather-graphite': 'rgb(84, 83, 79)',};

    this.images = {'summit': 'url("//skre.ca/cdn/shop/files/Summit-Swatch_68x.jpg?v=13892411646480289867")','solace': 'url("//skre.ca/cdn/shop/files/Solace-Swatch_68x.jpg?v=8465927282786385028")','drift': 'url("//skre.ca/cdn/shop/files/Drift-Swatch_68x.jpg?v=5799835184164277563")','carbon': 'url("//skre.ca/cdn/shop/files/Carbon-Swatch2_68x.jpg?v=10478435305601318083")','blue-white': 'url("//skre.ca/cdn/shop/files/Blue-White-Swatch_68x.jpg?v=15014167268203567615")','brown-gold': 'url("//skre.ca/cdn/shop/files/Brown-Gold-Swatch_68x.jpg?v=5526189180801042375")','green-gold': 'url("//skre.ca/cdn/shop/files/Green-Gold-Swatch_68x.jpg?v=6692574388150482346")','grey-white': 'url("//skre.ca/cdn/shop/files/Grey-White-Swatch_68x.jpg?v=8009045110532689137")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
